import { createContext, useState, useContext, useEffect } from "react";
import { createUrl, post, setStoredJwt } from "../network/AxiosInterceptor";

// Create the context
const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const getUserByRefreshToken = async () => {
      post(createUrl("/api/authentication/refresh"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data.message == "Access authorized") {
            const verifiedUser = {
              email: response.data.user.email,
              firstName: response.data.user.firstName,
              lastName: response.data.user.lastName,
              profilePic: response.data.user.profilePic,
              role: response.data.user.role ? response.data.user.role : "user",
            };
            setUser(verifiedUser);
            setStoredJwt(response.data.accesstoken);
            localStorage.setItem("refreshToken", response.data.refreshToken);
          } else {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            setUser({ role: "guest" });
          }
        })
        .catch((err) => {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          setUser({ role: "guest" });
        });
  };

  const fetchUser = async () => {
    await getUserByRefreshToken();
  };

  useEffect(() => {
    if (
      localStorage.getItem("refreshToken") &&
      localStorage.getItem("refreshToken") != "undefined"
    ) {
      try {
        fetchUser();
      } catch (e) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      }
    }else{
      setUser({ role: "guest" });
    }
  }, []);

  return (
    user ?
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
    :
    (
      <div className="flex flex-col items-center justify-center h-screen bg-red-50 bg-opacity-50 dark:bg-red-50">
        <div
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></div>
        <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
          Loading ...
        </p>
      </div>
    )
  );
};

// Create a custom hook for consuming the user context
export const useUser = () => {
  return useContext(UserContext);
};
